import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import ApiService from "../../services/apiService";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./LibrarySlider.css";

const defaultSlides = [
  {
    id: 1,
    image: "/campuslife/library/library_building2.JPG",
    title: "Central Library",
    subtitle: "Gateway to Knowledge and Research",
  },
  {
    id: 2,
    image: "/campuslife/library/readinghall2.JPG",
    title: "Reading Hall",
    subtitle: "Peaceful Environment for Study",
  },
  {
    id: 3,
    image: "/campuslife/library/readinghall3.JPG",
    title: "Silent Study Zone",
    subtitle: "Focused Learning Environment",
  },
  {
    id: 4,
    image: "/campuslife/library/booksection1.JPG",
    title: "Books Section",
    subtitle: "Thousands of Books & References",
  },
  {
    id: 5,
    image: "/campuslife/library/booksection5.JPG",
    title: "Journals & Periodicals",
    subtitle: "National & International Journals",
  },
  {
    id: 6,
    image: "/campuslife/library/digitallibrary2.JPG",
    title: "Digital Library",
    subtitle: "E-Books, E-Journals & Databases",
  },
  {
    id: 7,
    image: "/campuslife/library/studyarea1.JPG",
    title: "Study Area",
    subtitle: "Comfortable Learning Space",
  },
  {
    id: 8,
    image: "/campuslife/library/referencesection6.JPG",
    title: "Reference Section",
    subtitle: "Research & Reference Collection",
  },
  {
    id: 9,
    image: "/campuslife/library/readinghall4.JPG",
    title: "Academic Excellence",
    subtitle: "Supporting Students & Researchers",
  },
];

const LibrarySlider = () => {
  const [slides, setSlides] = useState(defaultSlides);

  useEffect(() => {
    loadImages();
  }, []);

  const loadImages = async () => {
    try {
      const response = await ApiService.getLibrarySliderImages();

      if (
        response?.success &&
        Array.isArray(response.data) &&
        response.data.length > 0
      ) {
        setSlides(response.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: true,
    fade: true,
  };

  return (
    <div className="library-slider">

      <Slider {...settings}>

        {slides.map((slide) => (

          <div key={slide.id}>

            <div className="slide-container">

              <img
                src={slide.image}
                alt={slide.title}
                className="slide-image"
                onError={(e) => {
                  e.target.src =
                    "/campuslife/library/library_building2.JPG";
                }}
              />

              <div className="overlay">

                <h1>{slide.title}</h1>

                <p>{slide.subtitle}</p>

              </div>

            </div>

          </div>

        ))}

      </Slider>

    </div>
  );
};

export default LibrarySlider;